import React from "react";
import {CFValue} from 'module/CustomField/type/CFType'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {AdaptCFValueInputComponent} from 'module/CustomField/component/input/AdaptCFValueInputComponent'

function adaptValueToView(value: CFValue): string {
	return !value && value !== 0 ? '' : value + ''
}
function adaptValueToModel(viewValue: string) {
	return viewValue === '' ? null : viewValue
}

export function CustomFieldRawInputComponent(props: CFComponentProps<CFValue>) {
	return (<div className={'CustomFieldRawInputComponent'}>
		<AdaptCFValueInputComponent {...props} adaptValueToView={adaptValueToView} adaptValueToModel={adaptValueToModel}/>
	</div>)
}